// extracted by mini-css-extract-plugin
module.exports = {"field":"tovjg","button":"fghwT","uploadAvatar":"_1yMgb","modalBox":"_2aNqK","header":"_3Qv76","body":"_2FunR"};